export default __webpack_public_path__ + "static/media/arcadeland_banner.002660fa.jpeg";